import React from 'react';
import ReactApexChart from 'react-apexcharts';

const SmallChart = ({ seed = 1, targetPercentage = 12.53 }) => {
  // Generate random increasing data points that reach the target percentage
  const generateData = (seed, targetPercentage) => {
    let data = [];
    const points = 20;
    // Start from a random percentage between 30-70% of target
    let value = targetPercentage * (0.3 + Math.random() * 0.4);
    const volatility = 0.8 + (seed * 0.4); // Increased volatility
    
    // Calculate average increment needed to reach target
    const totalDistance = targetPercentage - value;
    const avgIncrement = totalDistance / points;

    for (let i = 0; i < points; i++) {
      // Add more realistic random movements
      const randomDirection = Math.random() > 0.4 ? 1 : -1; // 60% chance of going up
      const randomMove = (Math.random() * volatility * avgIncrement);
      
      if (i === points - 1) {
        // Last point should be exactly the target
        value = targetPercentage;
      } else {
        // Add random movement but ensure we're generally trending towards target
        value += (avgIncrement * 0.5) + (randomDirection * randomMove);
        // Prevent going too low or too high
        value = Math.max(targetPercentage * 0.2, Math.min(targetPercentage * 1.5, value));
      }
      
      data.push(parseFloat(value.toFixed(2)));
    }
    return data;
  };

  const series = [{
    name: 'ROI',
    data: generateData(seed, targetPercentage)
  }];

  const options = {
    chart: {
      type: 'area',
      toolbar: {
        show: false
      },
      sparkline: {
        enabled: true
      },
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
      }
    },
    stroke: {
      curve: 'smooth',
      width: 1.5
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.2,
        stops: [0, 90, 100]
      }
    },
    colors: ['#00E396'],
    tooltip: {
      enabled: false
    },
    grid: {
      show: false
    },
    xaxis: {
      labels: {
        show: false
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      }
    },
    yaxis: {
      show: false // Hide the default y-axis
    },
    dataLabels: {
      enabled: false
    },
    annotations: {
      points: [{
        x: 10, // Middle of the chart
        y: series[0].data[10],
        marker: {
          size: 0
        },
        label: {
          text: `${targetPercentage.toFixed(2)}%`,
          style: {
            color: '#999',
            background: 'transparent',
            fontSize: '12px'
          },
          offsetY: 0
        }
      }]
    }
  };

  return (
    <div style={{ width: '100%', height: '60px' }}>
      <ReactApexChart
        options={options}
        series={series}
        type="area"
        height="100%"
      />
    </div>
  );
};

export default SmallChart;